import Layout from "./layouts/Layout/Layout";
import LoginPage from "./pages/LoginPage/LoginPage";
import RenderInvoicePage from "./pages/RenderInvoicePage/RenderInvoicePage";
import InvoicePage from "./pages/InvoicePage/InvoicePage";
import SelectInvoicePage from "./pages/SelectInvoicePage/SelectInvoicePage";
import AddOpenRolesPage from "./pages/AddOpenRoles/AddOpenRolesPage";
import AddCandidatePage from "./pages/AddCandidatePage/AddCandidatePage";
import RegisterPage from "./pages/RegisterPage/RegisterPage";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import './utils/axiosConfig';
import Guidelines from './pages/Guidelines/Guidelines'
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy'
import NotFound from "./pages/NotFound/NotFound";
import Dashboard from "./pages/Dashboard/Dashboard";
import AILabPage from "./pages/Accel/AILab";
import AILabTestPage from "./pages/Accel/AILab_test";
import AITestPage from "./pages/Accel/AITest";
import SubmitCandidatePage from "./pages/SubmitCandidatePage/SubmitCandidatePage";
import RayzeConsole from "./pages/RayzeConsole/RayzeConsole";
import ConfirmInterviewPage from "./pages/ConfirmInterviewPage/ConfirmInterviewPage";
import WorkOrderPage from "./pages/WorkOrderPage/WorkOrderPage";
import AdminPage from "./pages/AdminPage/AdminCRUD";
import MarketingRedirect from "./pages/MarketingRedirect";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/team" element={<MarketingRedirect path="/team" />} />
          <Route path="/clients" element={<MarketingRedirect path="/solutions" />} />
          <Route path="/rayze_og" element={<MarketingRedirect path="/" />} />
          <Route path="/story1" element={<MarketingRedirect path="/solutions" />} />
          <Route path="/story2" element={<MarketingRedirect path="/solutions" />} />
          <Route path="/story3" element={<MarketingRedirect path="/solutions" />} />
          <Route path="/story4" element={<MarketingRedirect path="/solutions" />} />
          <Route path="/story5" element={<MarketingRedirect path="/solutions" />} />
          <Route path="/story6" element={<MarketingRedirect path="/solutions" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/render_invoice/:id_str" element={<RenderInvoicePage />} />
          <Route path="/invoice" element={<InvoicePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/ailab" element={<AILabPage />} />
          <Route path="/ailab_test" element={<AILabTestPage />} />
          <Route path="/aitest" element={<AITestPage />} />
          <Route path='/guidelines' element={<Guidelines />} />
          <Route path='/policy' element={<PrivacyPolicy />} />
          <Route path="/select_invoice" element={<SelectInvoicePage />} />
          <Route path="/candidates" element={<AddCandidatePage />} />
          <Route path="/submit_candidates" element={<SubmitCandidatePage />} />
          <Route path="/open_roles" element={<AddOpenRolesPage />} />
          <Route path="/console" element={<RayzeConsole />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/confirm/:interview_id" element={<ConfirmInterviewPage />} />
          <Route path="/confirm_timeslot/:interview_id/:slot?" element={<ConfirmInterviewPage />} />
          <Route path="/work_order/:workOrderId" element={<WorkOrderPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
